import { render, staticRenderFns } from "./DividerLine.vue?vue&type=template&id=70685bbd&scoped=true&"
import script from "./DividerLine.vue?vue&type=script&lang=js&"
export * from "./DividerLine.vue?vue&type=script&lang=js&"
import style0 from "./DividerLine.vue?vue&type=style&index=0&id=70685bbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70685bbd",
  null
  
)

export default component.exports